// TODO: all the variant ids

import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import {
  AirRingColors,
  MiscRingCheckoutTypes,
  RingPriceData,
  RingSizes,
  RingType,
  RingVariantType,
} from './enums';
import { deepExpandStoreAliases } from '../../storeAliasHelper';

export const productMap_air_ring_PROD: Partial<
  Record<
    AirRingColors,
    Partial<Record<RingSizes, Record<RingType, RingVariantType>>>
  >
> = {
  [AirRingColors.ASTER_BLACK]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126744134',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304718578',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707409969212',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522343008',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713657662',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713657662',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40673028538438:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496296178:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145630780:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522343008:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522343008:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40673028538438',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44624496296178',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40681145630780',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329466976',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530156862',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530156862',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40673028538438:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496296178:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145630780:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329466976:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329466976:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/49202530156862:1',
        },
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126940742',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304882418',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410133052',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522506848',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713854270',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713854270',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669443948614:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515844338:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149040188:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522506848:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669443948614',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604515844338',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149040188',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329499744',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530189630',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530189630',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669443948614:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515844338:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149040188:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329499744:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873248886880:1',
        },
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127137350',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305046258',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410296892',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522670688',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714050878',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714050878',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669443981382:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515877106:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149072956:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522670688:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669443981382',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604515877106',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149072956',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329532512',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530222398',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530222398',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669443981382:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515877106:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149072956:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329532512:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873248919648:1',
        },
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127333958',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305210098',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410460732',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522834528',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714247486',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714247486',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444014150:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515909874:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149105724:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522834528:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444014150',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604515909874',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149105724',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329565280',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530255166',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530255166',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444014150:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515909874:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149105724:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329565280:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873248952416:1',
        },
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127530566',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305373938',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410624572',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522998368',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714444094',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714444094',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444046918:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515942642:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149138492:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522998368:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444046918',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604515942642',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149138492',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329598048',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530287934',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530287934',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444046918:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515942642:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149138492:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329598048:1',
          [ShopifyStore.EU]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/49202530287934:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873248985184:1',
        },
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127727174',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305537778',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410788412',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523162208',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714673470',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714673470',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444079686:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515975410:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149171260:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523162208:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444079686',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604515975410',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149171260',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329630816',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530320702',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530320702',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444079686:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604515975410:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149171260:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329630816:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249017952:1',
        },
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127923782',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305701618',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410952252',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523326048',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714870078',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714870078',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444112454:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516008178:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149204028:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523326048:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444112454',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604516008178',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149204028',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329663584',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530353470',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530353470',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444112454:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516008178:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149204028:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329663584:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249050720:1',
        },
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128120390',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305865458',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411116092',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523489888',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715066686',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715066686',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444145222:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516040946:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149236796:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523489888:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444145222',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44604516040946',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149236796',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329696352',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530386238',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530386238',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444145222:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516040946:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149236796:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329696352:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249083488:1',
        },
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128316998',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306029298',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411279932',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523653728',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715263294',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715263294',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40680286191686:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496361714:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145696316:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523653728:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40680286191686',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44624496361714',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40681145696316',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329729120',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530419006',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530419006',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40680286191686:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496361714:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145696316:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329729120:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249116256:1',
        },
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128513606',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306193138',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411443772',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523817568',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715459902',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715459902',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40680286257222:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496427250:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145761852:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523817568:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40680286257222',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44624496427250',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40681145761852',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329761888',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530451774',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530451774',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40680286257222:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44624496427250:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40681145761852:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329761888:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249149024:1',
        },
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AA00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128710214',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306356978',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411607612',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523981408',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715656510',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715656510',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444177990:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516073714:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149269564:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523981408:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AA00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40669444177990',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674066291',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40674149269564',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329794656',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202707988798',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202707988798',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40669444177990:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44604516073714:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40674149269564:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329794656:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249181792:1,39873251672160:1',
        },
      },
    },
  },

  [AirRingColors.MATTE_GREY]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126842438',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304816882',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410067516',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522441312',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713755966',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713755966',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737126842438:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026614514:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644229180:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522441312:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709003870278',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026614514',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644229180',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329827424',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530517310',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530517310',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709003870278:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026614514:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644229180:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329827424:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249214560:1',
        },
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127039046',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304980722',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410231356',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522605152',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713952574',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713952574',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737127039046:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026647282:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644261948:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522605152:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709003903046',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026647282',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644261948',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329860192',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530550078',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530550078',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709003903046:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026647282:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644261948:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329860192:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249247328:1',
        },
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127235654',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305144562',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410395196',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522768992',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714149182',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714149182',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737127235654:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026680050:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644294716:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522768992:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709003935814',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026680050',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644294716',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329892960',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530582846',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530582846',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709003935814:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026680050:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644294716:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329892960:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249280096:1',
        },
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127432262',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305308402',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410559036',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522932832',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714345790',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714345790',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737127432262:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026712818:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644327484:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522932832:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709003968582',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026712818',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644327484',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329925728',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530615614',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530615614',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709003968582:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026712818:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644327484:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329925728:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249312864:1',
        },
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127628870',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305472242',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410722876',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523096672',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714575166',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714575166',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737127628870:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026745586:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644360252:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523096672:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004001350',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026745586',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644360252',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329958496',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530648382',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530648382',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004001350:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026745586:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644360252:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329958496:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249345632:1',
        },
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127825478',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305636082',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410886716',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523260512',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714771774',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714771774',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737127825478:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026778354:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644393020:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523260512:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004034118',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026778354',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644393020',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262329991264',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530681150',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530681150',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004034118:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026778354:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644393020:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262329991264:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249378400:1',
        },
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128022086',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305799922',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411050556',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523424352',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714968382',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714968382',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737128022086:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026811122:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644425788:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523424352:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004066886',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026811122',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644425788',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330024032',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530713918',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530713918',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004066886:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026811122:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644425788:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330024032:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249411168:1',
        },
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128218694',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305963762',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411214396',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523588192',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715164990',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715164990',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737128218694:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026843890:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644458556:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523588192:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004099654',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026843890',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644458556',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330056800',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530746686',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530746686',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004099654:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026843890:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644458556:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330056800:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249443936:1',
        },
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128415302',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306127602',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411378236',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523752032',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715361598',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715361598',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737128415302:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026876658:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644491324:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523752032:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004132422',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026876658',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644491324',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330089568',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530779454',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530779454',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004132422:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026876658:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644491324:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330089568:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249476704:1',
        },
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128611910',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306291442',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411542076',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523915872',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715558206',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715558206',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40737128611910:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026909426:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644524092:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523915872:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004165190',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44663026909426',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644524092',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330122336',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530812222',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530812222',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004165190:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026909426:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644524092:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330122336:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249509472:1',
        },
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'MG00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128808518',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306455282',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411705916',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267524079712',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715754814',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715754814',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004197958:1,40737128808518:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026942194:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644556860:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267524079712:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'MG00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40709004197958',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674164595',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40700644556860',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330155104',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530844990',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530844990',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40709004197958:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44663026942194:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40700644556860:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330155104:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249542240:1,39873251672160:1',
        },
      },
    },
  },

  [AirRingColors.BIONIC_GOLD]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126776902',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304751346',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410001980',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522375776',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713690430',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713690430',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923222598:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629050098:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492538940:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522375776:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923222598',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629050098',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492538940',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330187872',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530877758',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530877758',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923222598:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629050098:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492538940:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330187872:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249575008:1',
        },
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126973510',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304915186',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410165820',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522539616',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713887038',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713887038',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923288134:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629115634:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492604476:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522539616:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923288134',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629115634',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492604476',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330220640',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530910526',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530910526',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923288134:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629115634:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492604476:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330220640:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249607776:1',
        },
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127170118',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305079026',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410329660',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522703456',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714083646',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714083646',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923353670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629181170:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492670012:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522703456:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923353670',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629181170',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492670012',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330253408',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530943294',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530943294',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923353670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629181170:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492670012:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330253408:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249640544:1',
        },
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127366726',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305242866',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410493500',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522867296',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714280254',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714280254',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923419206:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629246706:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492735548:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522867296:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923419206',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629246706',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492735548',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330286176',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202530976062',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202530976062',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923419206:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629246706:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492735548:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330286176:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249673312:1',
        },
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127563334',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305406706',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410657340',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523031136',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714509630',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714509630',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923484742:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629312242:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492801084:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523031136:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923484742',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629312242',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492801084',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330318944',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531008830',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531008830',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923484742:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629312242:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492801084:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330318944:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249706080:1',
        },
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127759942',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305570546',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410821180',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523194976',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714706238',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714706238',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923550278:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629377778:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492866620:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523194976:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923550278',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629377778',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492866620',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330351712',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531074366',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531074366',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923550278:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629377778:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492866620:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330351712:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249738848:1',
        },
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127956550',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305734386',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410985020',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523358816',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714902846',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714902846',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923615814:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629443314:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492932156:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523358816:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923615814',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629443314',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492932156',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330384480',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531139902',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531139902',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923615814:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629443314:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492932156:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330384480:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249771616:1',
        },
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128153158',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305898226',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411148860',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523522656',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715099454',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715099454',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923681350:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629508850:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492997692:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523522656:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923681350',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629508850',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492997692',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330417248',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531205438',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531205438',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923681350:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629508850:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492997692:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330417248:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249804384:1',
        },
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128349766',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306062066',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411312700',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523686496',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715296062',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715296062',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923746886:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629574386:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493063228:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523686496:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923746886',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629574386',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493063228',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330450016',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531270974',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531270974',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923746886:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629574386:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493063228:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330450016:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249837152:1',
        },
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128546374',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306225906',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411476540',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523850336',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715492670',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715492670',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923812422:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629639922:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493128764:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523850336:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923812422',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629639922',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493128764',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330482784',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531336510',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531336510',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923812422:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629639922:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493128764:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330482784:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249869920:1',
        },
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AG00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128742982',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306389746',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411640380',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267524014176',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715689278',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715689278',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923877958:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629705458:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493194300:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267524014176:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AG00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923877958',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674099059',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493194300',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330515552',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531402046',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531402046',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923877958:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629705458:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493194300:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330515552:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249902688:1,39873251672160:1',
        },
      },
    },
  },

  [AirRingColors.SPACE_SILVER]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737126809670',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304784114',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410034748',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522408544',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713723198',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713723198',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923255366:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629082866:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492571708:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522408544:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        //check once
        SKU: 'AS05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923255366',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629082866',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492571708',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330548320',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531467582',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531467582',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923255366:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629082866:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40707410034748:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330548320:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249935456:1',
        },
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127006278',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675304947954',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410198588',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522572384',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713919806',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713919806',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923320902:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629148402:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492637244:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522572384:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923320902',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629148402',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492637244',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330581088',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531500350',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531500350',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923320902:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629148402:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492637244:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330581088:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249968224:1',
        },
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127202886',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305111794',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410362428',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522736224',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714116414',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714116414',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923386438:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629213938:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492702780:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522736224:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923386438',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629213938',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492702780',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330613856',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531533118',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531533118',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923386438:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629213938:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492702780:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330613856:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250000992:1',
        },
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127399494',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305275634',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410526268',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267522900064',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714313022',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714313022',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923451974:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629279474:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492768316:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267522900064:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923451974',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629279474',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492768316',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330646624',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531565886',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531565886',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923451974:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629279474:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492768316:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330646624:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250033760:1',
        },
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127596102',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305439474',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410690108',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523063904',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714542398',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714542398',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923517510:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629345010:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492833852:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523063904:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923517510',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629345010',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492833852',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330679392',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531598654',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531598654',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923517510:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629345010:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492833852:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330679392:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250066528:1',
        },
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127792710',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305603314',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707410853948',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523227744',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714739006',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714739006',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923583046:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629410546:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492899388:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523227744:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923583046',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629410546',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492899388',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330712160',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531631422',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531631422',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923583046:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629410546:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492899388:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330712160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250099296:1',
        },
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737127989318',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305767154',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411017788',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523391584',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714935614',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714935614',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923648582:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629476082:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492964924:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523391584:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923648582',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629476082',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690492964924',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330744928',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531664190',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531664190',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923648582:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629476082:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690492964924:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330744928:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250132064:1',
        },
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128185926',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675305930994',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411181628',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523555424',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715132222',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715132222',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923714118:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629541618:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493030460:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523555424:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923714118',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629541618',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493030460',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330777696',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531696958',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531696958',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923714118:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629541618:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493030460:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330777696:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250164832:1',
        },
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128382534',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306094834',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411345468',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523719264',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715328830',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715328830',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923779654:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629607154:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493095996:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523719264:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923779654',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629607154',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493095996',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330810464',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531729726',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531729726',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923779654:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629607154:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493095996:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330810464:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250197600:1',
        },
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128579142',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306258674',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411509308',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267523883104',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715525438',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715525438',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923845190:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629672690:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493161532:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267523883104:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923845190',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44639629672690',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493161532',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330843232',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531762494',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531762494',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923845190:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629672690:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493161532:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330843232:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250230368:1',
        },
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'AS00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40737128775750',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/44675306422514',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40707411673148',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40267524046944',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715722046',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715722046',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923910726:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629738226:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493227068:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40267524046944:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'AS00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/40691923910726',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674131827',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/40690493227068',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40262330876000',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202531795262',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202531795262',
        },
        checkoutUrl: {
          [ShopifyStore.IN]:
            'https://ultrahumanstore.myshopify.com/cart/40691923910726:1,40666139033670:1',
          [ShopifyStore.AE]:
            'https://ultrahuman-mena.myshopify.com/cart/44639629738226:1,44599427891442:1',
          [ShopifyStore.ROW]:
            'https://ultrahuman-us.myshopify.com/cart/40690493227068:1,40672441401404:1',
          [ShopifyStore.US]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/40262330876000:1,39873251672160:1',
        },
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250263136:1,39873251672160:1',
        },
      },
    },
  },

  [AirRingColors.RAW_TITANIUM]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950193222',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092735218',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358352444',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644699232',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713788734',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713788734',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        //check once
        SKU: 'RT05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399559750',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728748274',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325355068',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641127520',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708250942',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708250942',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249935456:1',
        },
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950225990',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092800754',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358385212',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644732000',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202713985342',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202713985342',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399592518',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728781042',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325387836',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641160288',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708185406',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708185406',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873249968224:1',
        },
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950258758',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092833522',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358417980',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644764768',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714181950',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714181950',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399625286',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728846578',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325420604',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641193056',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708480318',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708480318',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250000992:1',
        },
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950291526',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092899058',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358450748',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644797536',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714378558',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714378558',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399658054',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728879346',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325453372',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641225824',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708414782',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708414782',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250033760:1',
        },
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950324294',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092931826',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358483516',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644830304',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714607934',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714607934',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399690822',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728944882',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325486140',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641258592',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708349246',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708349246',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250066528:1',
        },
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950357062',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092964594',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358516284',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644863072',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202714804542',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202714804542',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399723590',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624728977650',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325518908',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641291360',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202707956030',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202707956030',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250099296:1',
        },
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950389830',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625092997362',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358549052',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644895840',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715001150',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715001150',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399756358',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624729043186',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325551676',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641324128',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202707890494',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202707890494',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250132064:1',
        },
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950422598',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625093030130',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358581820',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644928608',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715197758',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715197758',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399789126',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624729075954',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325584444',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641356896',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202707824958',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202707824958',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250164832:1',
        },
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950455366',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625093095666',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358614588',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644961376',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715394366',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715394366',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399821894',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624729108722',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325617212',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641389664',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708119870',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708119870',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250197600:1',
        },
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950488134',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625093128434',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325649980',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542644994144',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715590974',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715590974',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399854662',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45624729141490',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325649980',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641422432',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202708054334',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202708054334',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250230368:1',
        },
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'RT00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362950520902',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/45625093161202',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273358680124',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542645026912',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202715787582',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202715787582',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]: '',
        },
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'RT00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/41362399887430',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674197363',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/41273325682748',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/40542641455200',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/49202707759422',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/49202707759422',
        },
        checkoutUrl: {},
        misc: {
          [MiscRingCheckoutTypes.BETTER_HELP_CHECKOUT]:
            'https://stelcore-x-ultrahuman.myshopify.com/cart/39873250263136:1,39873251672160:1',
        },
      },
    },
  },

  [AirRingColors.ROSE_GOLD]: {
    [RingSizes.FIVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR05',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR05',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054434374',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085667187',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669404220',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997741916256',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508196214',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508196214',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.SIX]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR06',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR06',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054467142',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085699955',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669436988',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997741949024',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508228982',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508228982',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.SEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR07',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR07',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054499910',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085732723',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669469756',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997741981792',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508261750',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508261750',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.EIGHT]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR08',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR08',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054532678',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085765491',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669502524',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742014560',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508294518',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508294518',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.NINE]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR09',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR09',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054565446',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085798259',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669535292',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742047328',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508327286',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508327286',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.TEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR10',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR10',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054598214',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085831027',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669568060',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742080096',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508360054',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508360054',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.ELEVEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR11',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR11',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054630982',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085863795',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669600828',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742112864',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508392822',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508392822',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.TWELVE]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR12',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR12',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054663750',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085896563',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669633596',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742145632',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508425590',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508425590',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.THIRTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR13',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR13',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054696518',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085929331',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669666364',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742178400',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508458358',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508458358',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.FOURTEEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR14',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR14',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054729286',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52642085962099',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669699132',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742211168',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508491126',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508491126',
        },
        checkoutUrl: {},
      },
    },
    [RingSizes.OPEN]: {
      [RingType.ENGRAVED]: {
        SKU: 'BR00',
        variantId: {},
        checkoutUrl: {},
      },
      [RingType.NOT_ENGRAVED]: {
        SKU: 'BR00',
        variantId: {
          [ShopifyStore.IN]: 'gid://shopify/ProductVariant/43319054762054',
          [ShopifyStore.AE]: 'gid://shopify/ProductVariant/52757674230131',
          [ShopifyStore.ROW]: 'gid://shopify/ProductVariant/42898669731900',
          [ShopifyStore.US]: 'gid://shopify/ProductVariant/41997742243936',
          [ShopifyStore.EU]: 'gid://shopify/ProductVariant/55758508523894',
          [ShopifyStore.GB]: 'gid://shopify/ProductVariant/55758508523894',
        },
        checkoutUrl: {},
      },
    },
  },
};

export const pricingMap_air_ring_PROD: Partial<
  Record<AirRingColors, Partial<Record<string | ShopifyStore, string | number>>>
> = {
  [AirRingColors.ASTER_BLACK]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.ASTER_BLACK].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.ASTER_BLACK].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.ASTER_BLACK].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.ASTER_BLACK].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.ASTER_BLACK].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.ASTER_BLACK].price,
    displayName: 'Ultrahuman Ring AIR | Aster Black',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
  [AirRingColors.MATTE_GREY]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.MATTE_GREY].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.MATTE_GREY].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.MATTE_GREY].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.MATTE_GREY].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.MATTE_GREY].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.MATTE_GREY].price,
    displayName: 'Ultrahuman Ring AIR | Matte Grey',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
  [AirRingColors.BIONIC_GOLD]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.BIONIC_GOLD].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.BIONIC_GOLD].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.BIONIC_GOLD].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.BIONIC_GOLD].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.BIONIC_GOLD].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.BIONIC_GOLD].price,
    displayName: 'Ultrahuman Ring AIR | Bionic Gold',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
  [AirRingColors.SPACE_SILVER]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.SPACE_SILVER].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.SPACE_SILVER].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.SPACE_SILVER].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.SPACE_SILVER].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.SPACE_SILVER].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.SPACE_SILVER].price,
    displayName: 'Ultrahuman Ring AIR | Space Silver',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
  [AirRingColors.RAW_TITANIUM]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.RAW_TITANIUM].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.RAW_TITANIUM].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.RAW_TITANIUM].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.RAW_TITANIUM].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.RAW_TITANIUM].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.RAW_TITANIUM].price,
    displayName: 'Ultrahuman Ring AIR | Raw Titanium',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
  [AirRingColors.ROSE_GOLD]: {
    [ShopifyStore.IN]:
      RingPriceData[ShopifyStore.IN][AirRingColors.ROSE_GOLD].price,
    [ShopifyStore.AE]:
      RingPriceData[ShopifyStore.AE][AirRingColors.ROSE_GOLD].price,
    [ShopifyStore.ROW]:
      RingPriceData[ShopifyStore.ROW][AirRingColors.ROSE_GOLD].price,
    [ShopifyStore.US]:
      RingPriceData[ShopifyStore.US][AirRingColors.ROSE_GOLD].price,
    [ShopifyStore.EU]:
      RingPriceData[ShopifyStore.EU][AirRingColors.ROSE_GOLD].price,
    [ShopifyStore.GB]:
      RingPriceData[ShopifyStore.GB][AirRingColors.ROSE_GOLD].price,
    displayName: 'Ultrahuman Ring AIR | Brushed Rose Gold',
    description:
      "World's lightest smart ring | Track sleep, movement, recovery",
  },
};

// Apply store aliasing to expand GB/AU/CA configurations
// This automatically fills in aliased stores (GB->EU, AU->EU, CA->US)
export const productMap_air_ring_PROD_expanded = deepExpandStoreAliases(productMap_air_ring_PROD);
